// O-4756. The oversubscribed warning appears on three surfaces — the complex
// editor's split preview, the simple editor's split card, and the settlement
// table — and a booker who reads one wording in the editor and a different one
// on the settlement they send out has to work out whether they are the same
// problem. One string, three surfaces.
//
// The body names all three causes deliberately: the flag tracks the money
// ACTUALLY allocated, so shares totalling over 100% is only one way to trip it —
// guarantees consuming the pool and a payout floor lifting a member above their
// share do it too, and a booker told only about percentages will stare at
// numbers that already add to 100.
export const OVERSUBSCRIBED_LABEL = 'Oversubscribed';
export const OVERSUBSCRIBED_BODY =
  'The lineup is allocated more than the pool holds. '
  + 'Check the member shares, guarantees and payout floors.';

// The counterpart, and it belongs on the same three surfaces for the same
// reason. Over-allocation announces itself; UNDER-allocation looks like an
// ordinary split — a 60/30 typo, or a versus member who took their guarantee
// and forfeited their share, previews as normal while the artist settles short.
// Showing it only in the editor leaves it invisible on the document that
// actually gets signed and emailed.
export const UNALLOCATED_BODY =
  'the lineup is not claiming all of the pool, so the balance stays with the venue.';
